<template>
	<form id="mainForm" action="#" method="post">
		<Card>
			<template #title>
				<Toolbar>
					<template #left>
						<div class="p-card-title">
							[{{mode}}] {{$t('transporter')}}
						</div>
						<div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
							<Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true" aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

							<OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel" style="width: 550px" :breakpoints="{'960px': '80vw'}">
								<div class="p-grid p-field">
									<div class="p-row">
										<i class="pi pi-plus-circle" /> {{this.$formatDateTime(header.Create_Date)}} 
									</div>
									<div class="p-row">
										by {{header.Create_By}}
									</div>
								</div>
								<div class="p-grid p-field" v-if="header.Edit_Date">
									<div class="p-row">
										<i class="pi pi-pencil" /> {{this.$formatDateTime(header.Edit_Date)}} 
									</div>
									<div class="p-row">
										by {{header.Edit_By}}
									</div>
								</div>
							</OverlayPanel>
						</div>
					</template>

					<template #right>
						<Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="back()" />
					</template>
				</Toolbar>
			</template>
			<template #content>
				<TabView>
					<TabPanel :header="$t('header_details')">
						<div v-if="header && isOverNotAccess">
							<Message severity="warn" :closable="false">
								{{ $t('inactive_account') }} ({{ Is_Locked ? 'Locked' : 'Unlocked'}})
							</Message>
						</div>
						<div class="col-12 grid">
						<div class="col-7">
							<Card class="normal-card">
							<template #content>
								<div class="p-inputtext-sm p-fluid">
								<FormField
									v-model="header"
									fieldName="Code"
									:labelName="$t('code')"
									fieldClass="col-7"
									labelClass="col-3"
								>
									<InputText
									v-model="header.Code"
									type="text"
									class="p-inputtext-sm"
									v-if="header"
									disabled
									/>
								</FormField>
								<FormField
									v-model="header"
									fieldName="Name"
									:labelName="$t('name')"
									fieldClass="col-7"
									labelClass="col-3"
								>
									<InputText
									v-model="header.Name"
									type="text"
									class="p-inputtext-sm"
									v-if="header"
									disabled
									/>
								</FormField>
								<FormField
									:modelValue="header"
									fieldName="Password"
									:labelName="$t('password')"
									fieldClass="col-7"
									labelClass="col-3"
								>
									<Button
									type="button"
									label="Change Password"
									@click="changePass(header)"
									v-if="header"
									:disabled="this.mode == this.$FORM_MODE_VIEW"
									/>
									<!-- <InputText
									v-model="header.Password"
									type="password"
									class="p-inputtext-sm"
									v-if="header"
									@click="changePass(header)"
									/> -->
								</FormField>
								<FormField labelName="Lock/Unlock Account" fieldName="Lock_Unlock" v-model="header" labelClass="col-3" fieldClass="col-7">
									<Button label="Lock/Unlock Account" class="p-button-warning" v-if="header" :disabled="this.mode == this.$FORM_MODE_VIEW" @click="openDialog" />
								</FormField>
								<FormField
									v-model="header"
									fieldName="Email"
									:labelName="$t('email')"
									fieldClass="col-7"
									labelClass="col-3"
								>
									<InputText
									v-model="header.Email"
									type="email"
									class="p-inputtext-sm"
									v-if="header"
									disabled
									/>
								</FormField>
								<FormField
									v-model="header"
									fieldName="Address"
									:labelName="$t('address')"
									fieldClass="col-7"
									labelClass="col-3"
								>
									<InputText
									v-model="header.Address"
									type="text"
									class="p-inputtext-sm"
									v-if="header"
									disabled
									/>
								</FormField>
								<FormField
									v-model="header"
									fieldName="Phone"
									:labelName="$t('phone')"
									fieldClass="col-7"
									labelClass="col-3"
								>
									<InputText
									v-model="header.Phone"
									v-if="header"
									class="p-inputtext-sm"
									disabled
									/>
								</FormField>
								<FormField
									v-model="header"
									fieldName="Fax"
									:labelName="$t('fax')"
									fieldClass="col-7"
									labelClass="col-3"
								>
									<InputText
									v-model="header.Fax"
									type="text"
									class="p-inputtext-sm"
									v-if="header"
									disabled
									/>
								</FormField>
								<FormField
									v-model="header"
									fieldName="Contact_Person"
									:labelName="$t('contact_person')"
									fieldClass="col-7"
									labelClass="col-3"
								>
									<InputText
									v-model="header.Contact_Person"
									type="text"
									class="p-inputtext-sm"
									v-if="header"
									disabled
									/>
								</FormField>
								</div>
							</template>
							<template #footer>
								<div style="display: flex; justify-content: flex-end">
								
								<Button
									label="Save"
									class="col-1 p-button-success"
									@click="save()"
									:disabled="this.header ? false : true"
									v-if="this.mode != this.$FORM_MODE_VIEW"
								/>
								</div>
							</template>
							</Card>
						</div>
						<div v-show="userRole != 'TRANSPORTER'" class="col-5">
							<Card class="normal-card">
							<template #content>
								<DataTable
								:loading="!this.header"
								:value="this.header ? this.header.Locations : null"
								responsiveLayout="scroll"
								class="p-datatable-sm editable-cells-table"
								:paginator="true"
								:rows="5"
								:rowClass="rowClass"
								:totalRecords="
									this.header
									? this.header.Locations
										? this.header.Locations.length
										: 0
									: 0
								"
								v-if="this.mode != this.$FORM_MODE_VIEW"
								>
								<Column :exportable="false" :sortable="false" class="h-3rem">
									<template #header>
									<Button
										icon="pi pi-plus"
										class="p-button-info p-button-sm"
										@click="addLocation()"
									/>
									</template>
									<template #body="slotProps">
									<Button
										icon="pi pi-minus"
										class="p-button-danger p-button-sm"
										@click="removeLocation(slotProps.data)"
									/>
									</template>
								</Column>
								<Column field="Location_Code" :header="$t('location')">
									<template #body="slotProps">
									<CustomSelect
										v-model="slotProps.data[slotProps.column.props.field]"
										:url="this.$API_URL + 'list/location_code'"
										:minLength="0"
										:filter="true"
										class="p-inputtext-sm"
										style="display: flex"
										@change="editLocation(slotProps.data)"
									/>
									</template>
								</Column>
								</DataTable>
								<DataTable
								:loading="!this.header"
								:value="this.header ? this.header.Details : null"
								responsiveLayout="scroll"
								:paginator="true"
								:rows="5"
								:totalRecords="
									this.header
									? this.header.Details
										? this.header.Details.length
										: 0
									: 0
								"
								class="p-datatable-sm editable-cells-table"
								>
								<Column
									field="Sales_Organization_Code"
									:exportable="false"
									:sortable="false"
									class="h-3rem"
								>
									<template #header> Purchase Organization Code </template>
								</Column>
								</DataTable>
							</template>
							</Card>
						</div>
						</div>
					</TabPanel>
					<TabPanel :header="$t('driver')">
						<Driver
							:header="header ? header.Drivers : null"
							:transporter_code="header ? header.Code : ''"
							@block-ui="block"
							@unblock-ui="unBlock"
							@refresh-data="refreshData"
							:transporterHeader="header"
							:mode="mode"
							/>
					</TabPanel>
					<TabPanel :header="$t('truck')">
						<Truck
							:header="header ? header.Vehicles : null"
							:transporter_code="header ? header.Code : ''"
							@block-ui="block"
							@unblock-ui="unBlock"
							@refresh-data="refreshData"
							:transporterHeader="header"
							:mode="mode"
							/>
					</TabPanel>
					<TabPanel :header="$t('user')">
						<User
							:header="header ? header.UsersModel : null"
							:transporter_code="header ? header.Code : ''"
							@block-ui="block"
							@unblock-ui="unBlock"
							@refresh-data="refreshData"
							:transporterHeader="header"
							:mode="mode"
							/>
					</TabPanel>
				</TabView>
			</template>
		</Card>
		
		<ChangePassword
		v-model:isVisible="this.isVisible"
		v-model:model="modelPassword"
		:userId="this.userId"
		@block-ui="block"
		@unblock-ui="unBlock"
		:changeFirstLogin="true"
		/>

		<Dialog header="Lock/Unlock Account" v-model:visible="displayDialog" :closable="false" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '30vw'}">
			<div>
				<Message severity="warn" :closable="false">
                    {{ inactive_msg }} ({{ Is_Locked ? 'Locked' : 'Unlocked'}})
                </Message>
				<h6 id="single">Please select lock or unlock account</h6>
				<SelectButton v-model="Is_Locked" :options="lockOption" optionLabel="name" optionValue="value" aria-labelledby="single" />
			</div>
			<template #footer>
				<Button label="Cancel" icon="pi pi-times" @click="closeDialog" class="p-button-text"/>
				<Button label="Save" icon="pi pi-check" @click="saveLockUser" />
			</template>
		</Dialog>
	</form>
</template>
<script>
import Driver from "../Transporter/_Driver.vue";
import Truck from "../Transporter/_Truck.vue";
import User from "../Transporter/_User.vue";

export default {
  	name: "TransporterEditor",
  	data() {
		return {
			mode: null,
			code: null,
			type: null,
			indexName: "TransporterIndex",
			url: this.$API_URL + "transporter/",
			header: null,
			detail: null,
			locations: null,
			drivers: null,
			truck: null,
			vehicle: null,
			link: "www.google.com",
			isVisible: false,
			userId: null,

			vehiclesData:[],
			usersData:[],
			driversData: [],

			Is_Locked: null,
			lockOption: [
				{name: 'Lock', value: true},
				{name: 'Unlock', value: false},
			],
			displayDialog:false,
			inactive_msg: ''
		};
	},
  components: {
    Driver: Driver,
    Truck: Truck,
    User: User,
  },
  computed: {
	  userRole() {
		  return this.$store.getters.getRole;
	  }
  },
  methods: {
    changePass(data) {
      this.isVisible = !this.isVisible;
      this.modelPassword = data;
      this.userId = this.header.Code;
    },
    rowClass(data) {
      return data
        ? data.mode == this.$FORM_MODE_DELETE
          ? "hidden"
          : ""
        : null;
    },
    init() {
      var self = this;
      this.$axios
        .get(this.url + this.mode + "/" + this.code + "/" + this.type)
        .then((response) => {
          self.header = response.data.data.header;
          self.detail = response.data.data.detail;
          self.locations = response.data.data.locations;
		  self.Is_Locked = response.data.data.header.Is_Blocked;
        })
        .catch((err) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: 50000,
          });
        });
    },
	refreshData(){
		this.header = null;
		this.detail = null;
		this.locations = null;
		var self = this;
		this.$axios
			.get(this.url + this.mode + "/" + this.code + "/" + this.type)
			.then((response) => {
				self.header = response.data.data.header;
				self.detail = response.data.data.detail;
				self.locations = response.data.data.locations;
				self.Is_Locked = response.data.data.header.Is_Blocked;
			})
			.catch((err) => {
				self.$toast.add({
					severity: "error",
					summary: "Error",
					detail: err,
					life: 50000,
				});
			});
	},
    save() {
      this.$emit("block-ui");
      this.$axios
        .post(this.url + "save", this.header)
        .then((response) => {
          this.$emit("unblock-ui");
          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "",
            life: 50000,
          });
        })
        .catch((err) => {
          this.$emit("unblock-ui");
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: 50000,
          });
        });
    },
	saveLockUser(){
		var self = this;
		var data = {
			"user_id": this.header.User_Id,
			"is_locked": this.Is_Locked
		};

		this.$emit('block-ui');
		this.$axios.post(this.$API_URL + "util/user_lock_unlock/", data)
		.then((response) => {
			self.init();
			self.$emit('unblock-ui');
			self.closeDialog();
			if (response.data.success){
				self.$toast.add({ severity: 'success', summary: 'Success Saving Data', detail: "Transporter account has been saved successfully.", life: 50000});
			}
			else{
				self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: error, life: 5000});
			}
		})
		.catch(function (error) {
			self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: error, life: 5000});
			self.$emit('unblock-ui');
		});
	},
    back() {
      this.$router.push({
        name: "Transporter",
        params: { type: this.type ? this.type : "Index" },
      });
    },
    addLocation() {
      let newDetail = this.locations;
      var det = { ...newDetail };
      det.mode = this.$FORM_MODE_CREATE;
      this.header.Locations.push(det);
    },
    editLocation(data) {
      if (data.mode == this.$FORM_MODE_UNCHANGED) {
        data.mode = this.$FORM_MODE_EDIT;
      }
    },
    removeLocation(data) {
      if (data.mode == this.$FORM_MODE_CREATE) {
        var index = this.header.Locations.indexOf(data);
        this.header.Locations.splice(index, 1);
      } else {
        data.mode = this.$FORM_MODE_DELETE;
      }
    },
    block() {
      this.$emit("block-ui");
    },
    unBlock() {
      this.$emit("unblock-ui");
    },
	openDialog(){
		this.inactiveMsg();
		this.displayDialog = true;
	},
	closeDialog(){
		this.displayDialog = false;
		this.Is_Locked = this.header.Is_Blocked;
	},
	inactiveMsg(){
		var userAccount = this.header;
		var lastAccessDate = new Date(this.$moment(userAccount.Last_Access_Date).format('L'));
		var currentDate = new Date(this.$moment(new Date()).format('L'));

		var lastDuration = currentDate.getTime() - lastAccessDate.getTime();
		var totalDays = lastDuration / (1000 * 3600 * 24);

		if(isNaN(totalDays)){
			this.inactive_msg = "This account has never been active. ";
		}
		else{
			this.inactive_msg = "This account has been inactive for "+totalDays+" days. ";
		}
	}
  },
  created() {
    this.mode = this.$route.query.mode;
    this.code = this.$route.query.code ?? "";
    this.type = this.$route.query.type;
    this.init();
  },
  computed:{
	isOverNotAccess(){
		var duration = 90;
		var userAccount = this.header;
		var lastAccessDate = new Date(this.$moment(userAccount.Last_Access_Date).format('L'));
		var currentDate = new Date(this.$moment(new Date()).format('L'));

		if(userAccount.Last_Access_Date == null){
			return true;
		}
		else{
			var lastDuration = currentDate.getTime() - lastAccessDate.getTime();
			var totalDays = lastDuration / (1000 * 3600 * 24);

			if(totalDays >= duration){
				return true;
			}

			return false;
		}
	}
  }
};
</script>
<style scoped>
.normal-card {
  box-shadow: 0 -3px 0px 0px rgb(0 173 255 / 100%), 0 0px 0px 0 rgb(0 0 0 / 14%),
    0 0px 0px 0px rgb(0 0 0 / 12%);
}

.hidden {
  display: none;
}
</style>
